import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import { Box } from "@mui/material";
import PublicIcon from '@mui/icons-material/Public';

const DashboardCountriesChart = ({ bestCountries }) => {
  const chartRef = useRef(null);
  const [expanded, setExpanded] = useState(false);

  const onClickHandler = () => {
    setExpanded(!expanded);
  };

  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    if (chartRef.current && bestCountries && bestCountries.length > 0) {
      const labels = bestCountries.map((item) => item.label);
      const values = bestCountries.map((item) => item.data);

      const chartData = {
        labels: labels,
        datasets: [
          {
            label: "Kargo Sayısı",
            data: values,
            backgroundColor: "rgba(58, 141, 255, 0.85)",
            borderColor: "#3a8dff",
            borderWidth: 1,
            borderRadius: 6,
            barPercentage: 0.5,
          },
        ],
      };

      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 1.8,
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              maxRotation: 0,
              autoSkip: true,
              maxTicksLimit: 5,
              font: { size: 11, weight: '500' }
            }
          },
          y: {
            beginAtZero: true,
            grid: { color: "rgba(0, 0, 0, 0.05)", drawBorder: false },
            ticks: {
              stepSize: 1,
              font: { size: 11 }
            },
          },
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: 'rgba(31, 41, 55, 0.95)',
            titleFont: { size: 14, weight: 'bold' },
            bodyFont: { size: 13 },
            padding: 12,
            cornerRadius: 10,
            displayColors: true,
            callbacks: {
              label: function(context) {
                return ` ${context.dataset.label}: ${context.parsed.y} Paket`;
              }
            }
          }
        },
      };

      chartInstance.current = new Chart(chartRef.current, {
        type: "bar",
        data: chartData,
        options: chartOptions,
      });
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [bestCountries]);

  return (
    <Box className={`pie-chart ${expanded ? "expanded" : ""}`}>
      <div className="pie-chart-header">
        <div className="chart-header-left">
          <div className="shipment-count-icon-wrapper cart">
            <PublicIcon />
          </div>
          <div className="chart-header-text">
            <div className="pie-text-total">Ülkeler</div>
          </div>
        </div>
      </div>
      <div style={{ height: "250px" }}>
        {bestCountries?.length === 0 ? (
          <div className="no-data-text">Gönderiniz bulunmamaktadır.</div>
        ) : (
          <canvas ref={chartRef} />
        )}
      </div>
      <div className="pie-chart-footer">
        <div className="count-button">
          <button onClick={onClickHandler}>
            {expanded ? "Daha Az Göster" : "Daha Fazla Göster"}
          </button>
        </div>
      </div>
    </Box>
  );
};

export default DashboardCountriesChart;
